import { Component, OnInit } from '@angular/core';
import {InfoApiService} from '../../../../services/rest-api/info.api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HssResponse} from '../../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../../services/rest-api/HssErrorResponse';
import {SeoService} from '../../../../services/seo/seo.service';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-staffmember',
  templateUrl: './staffmember.component.html',
  styleUrls: ['./staffmember.component.scss']
})
export class StaffmemberComponent implements OnInit {

  public deptId: number = 0;

  memberid : number = 0;
  profile : string = "";
  member: any;
  links: any[] = [];
  public publications: any[] = [];
  public specialities: any[] = [];

  citeText: any;

  // loaders
  staffLoader: boolean = false;
  staffRepat: any[] = [1,2,3,4,5];

  constructor(
    private _info: InfoApiService,
    private _actRoute: ActivatedRoute,
    private router: Router,
    private seo: SeoService
  ) { }

  ngOnInit(): void {
    this._actRoute.paramMap.subscribe(params => {

      this.deptId = this._actRoute.snapshot.params.deptid;
      this.profile = String(this._actRoute.snapshot.paramMap.get('profile'));

      // get the memeber id from profile
      this.getMemberByProfile(this.profile);

    });
  }

  // Get the staff member
  getMember(memberId: number){
    this.staffLoader = true;
    this._info.getStaffMember(memberId).subscribe (
      (response: HssResponse<any>) => {
        this.member = response.body[0];
        this.staffLoader = false;

        this.seo.setMeta(this.member?.title+'. '+this.member?.full_name+' ('+environment.faculty_url+'/staff/'+this.profile+')');
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get the staff member id by profile name
  getMemberByProfile(profile: string){
    this._info.getMemberByProfile(profile).subscribe (
      (response: HssResponse<any>) => {
        this.memberid = response.body[0].id;

        //Get the staff member
        this.getMember(this.memberid)

        // Get links for the member
        this.getLinks(this.memberid);

        // Get unique available publication types for the member
        this.getUniquePubTypes(this.memberid);

        // Get specialities for the member by speciality type
        this.getSpecialities(this.memberid)
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get links for the staff member
  getLinks(memberId: number){
    this._info.getLinks(memberId).subscribe (
      (response: HssResponse<any>) => {
        this.links = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get publications for the staff member according to types
  getUniquePubTypes(memberId: number){
    this._info.getUniquePubTypes(memberId).subscribe (
      (response: HssResponse<any>) => {
        this.publications = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get specialities for the staff member according to speciality types
  getSpecialities(memberId: number){
    this._info.getSpecialities(memberId).subscribe (
      (response: HssResponse<any>) => {
        this.specialities = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  removeHTML(str: any){
    let tmp = document.createElement("p");
    tmp.innerHTML = str;
    return tmp.textContent || tmp.innerText || "";
  }
}
